import PageNav from "../components/PageNav";
import styles from "./Product.module.css";

export default function Product() {
  return (
    <main className={styles.product}>
      <PageNav />
      <section>
        <img
        className={styles.product_img}
          src="img-1.jpg"
          alt="person with dog overlooking mountain with sunset"
        />
        <div>
          <h2>🏔️ About WorldWise.</h2>
          <p>
            At WorldWise, we believe every journey tells a story — from city streets to mountain peaks. Whether you're a weekend adventurer or a world traveler, our platform helps you map out memories, document destinations, and share your footsteps with the world.
          </p>
          <p>
            Born from a love of exploration and the desire to keep every moment alive, WorldWise combines smart mapping with personal journaling to make travel more meaningful.
            With features like city pins, location notes, and a global visual diary, we make it simple to track where you've been and inspire where you'll go next.
          </p>
        </div>
      </section>
    </main>
  );
}
